module.exports = __webpack_public_path__ + "static/media/pwa.bd5f4148.png";